export class dashboardKPIModel {
  SubmissionCount: number;
  QuotedCount: number;
  BoundCount: number;
  ConversionRatio: number;
  CommissionsPaid: number;
  ClaimsIncurred: number;
  GrossWrittenPremium: number;
}
